import {
	attachInstruction,
	extractInstruction,
} from "@atlaskit/pragmatic-drag-and-drop-hitbox/tree-item";
import { createContext } from "react";
import type { MoveItemArgs, TreeItem } from "../primitives/types";

export type TreeContextValue = {
	uniqueContextId: symbol;
	getPathToItem: (itemId: string) => string[];
	findItemBranch: (itemId: string) => string | null | undefined;
	getItem: (itemId: string) => TreeItem | undefined;
	itemHasChildren: (itemId: string) => boolean;
	onMoveItem: (args: MoveItemArgs) => void;
	subscribeItemOpen: (itemId: string, listener: () => void) => () => void;
	getItemOpen: (itemId: string) => boolean;
	registerTreeItem: (args: {
		itemId: string;
		element: HTMLElement;
		actionMenuTrigger: HTMLElement;
	}) => () => void;
	setItemOpen: (itemId: string, open: boolean) => void;
	toggleItemOpen: (itemId: string) => void;
	dragAndDropEnabled: boolean;
};

export const TreeContext = createContext<TreeContextValue>({
	uniqueContextId: Symbol("uniqueId"),
	getPathToItem: () => [],
	findItemBranch: () => undefined,
	getItem: () => undefined,
	itemHasChildren: () => false,
	onMoveItem: () => {},
	subscribeItemOpen: () => () => {},
	getItemOpen: () => false,
	registerTreeItem: () => () => {},
	setItemOpen: () => {},
	toggleItemOpen: () => {},
	dragAndDropEnabled: true,
});

export type DependencyContextValue = {
	attachInstruction: typeof attachInstruction;
	extractInstruction: typeof extractInstruction;
};

export const DependencyContext = createContext<DependencyContextValue>({
	attachInstruction: attachInstruction,
	extractInstruction: extractInstruction,
});
